import { useTheme } from '@/src/context/ThemeContext';
import { OnboardingScreen } from '@/src/presentation/screens/OnboardingScreen';
import { ONBOARDING_FLAG_KEY, NOTIFICATIONS_PERMISSION_KEY } from '@/src/core/utils/storageKeys';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useRouter } from 'expo-router';
import { useEffect } from 'react';
import { Platform } from 'react-native';
import * as Notifications from 'expo-notifications';
import { logger } from '@/src/core/utils';

export default function OnboardingContainer() {
  const router = useRouter();
  const { colors } = useTheme();

  useEffect(() => {
    // Clear the flag immediately so it never shows again
    AsyncStorage.removeItem(ONBOARDING_FLAG_KEY).catch((error) => {
      logger.warn('Onboarding', 'Failed to clear onboarding flag', { error });
    });
  }, []);

  const handleSkip = () => {
    router.replace('/');
  };

  const handleExplore = () => {
    router.replace('/explore');
  };

  const markNotifPrimerSeen = async () => {
    try {
      await AsyncStorage.setItem(NOTIFICATIONS_PERMISSION_KEY, 'true');
    } catch (error) {
      logger.warn('Onboarding', 'Failed to save notifications primer flag', { error });
    }
  };

  const handleRequestNotificationPermission = async () => {
    if (Platform.OS !== 'web') {
      await markNotifPrimerSeen();
      try {
        // Trigger the native system dialog
        await Notifications.requestPermissionsAsync();
      } catch (error) {
        logger.warn('Onboarding', 'Failed to request notification permission', { error });
      }
    }
    router.replace('/create-tournament');
  };

  const handleNotifLater = async () => {
    // Mark primer as seen so NotificationContext can request next time (on re-login)
    if (Platform.OS !== 'web') {
      await markNotifPrimerSeen();
    }
    router.replace('/create-tournament');
  };

  return (
    <OnboardingScreen
      onSkip={handleSkip}
      onCreateTournament={handleNotifLater}
      onExplore={handleExplore}
      onRequestNotificationPermission={handleRequestNotificationPermission}
      colors={colors}
    />
  );
}
